/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'

/**
 * Typescript enum
 */

export enum SetupIntentPurpose {
  subscription_free_coupon = 'subscription_free_coupon'
}

/**
 * SetupIntentPurpose
 *
 * The purpose of the setup intent
 */
export const SetupIntentPurposeEnumType = types.enumeration('SetupIntentPurpose', ['subscription_free_coupon'])
